import React, { useEffect, useRef } from "react";
import {
  DeviceSectionContainer,
  DeviceTextContainer,
  DeviceTitle,
  DeviceDescription,
  DeviceImage,
} from "./styles";

const DeviceSection: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <DeviceSectionContainer ref={sectionRef}>
      <DeviceTextContainer>
        <DeviceTitle>{`데스크탑, 태블릿PC\n스마트폰으로\n언제 어디서나`}</DeviceTitle>
        <DeviceDescription>{`보건선생님이 계신 곳\n어디에서나\n스마일보건과 함께`}</DeviceDescription>
      </DeviceTextContainer>
      <DeviceImage src="/images/home-device.webp" alt="반응형 디자인 소개" />
    </DeviceSectionContainer>
  );
};

export default DeviceSection;
